import api from "./api";

const PATH = "/api/v1/plaid";

export const PlaidService = {
  async createLinkToken(): Promise<string> {
    const response = await api.get(`${PATH}/create_link_token`);
    console.log("Link token response:", response);
    return response.data.data;
  },
  async exchangePublicToken(public_token: string): Promise<string> {
    const response = await api.post(`${PATH}/exchange_public_token`, {
      public_token,
    });
    console.log("Exchange public token response:", response);
    return response.data.data;
  },
  async syncAccounts(): Promise<any> {
    const response = await api.post(`${PATH}/sync_accounts`);
    console.log("Sync Accounts response:", response);
    return response.data.data;
  },
  async syncStatements(): Promise<any> {
    const response = await api.post(`${PATH}/sync_statements`);
    console.log("Sync Statements response:", response);
    return response.data.data;
  },
  async syncTransactions(): Promise<any> {
    const response = await api.post(`${PATH}/sync_transactions`);
    console.log("Sync Transactions response:", response);
    return response.data.data;
  },
};
